import React, { useEffect, useState } from 'react';

import { Container, Card, Tab, Nav } from 'react-bootstrap';
import Swal from 'sweetalert2';

import { getConfiguration } from 'apis/admin/configApi';

import SimpleHeader from 'components/Headers/SimpleHeader';
import DefaultMetaTag from './DefaultMetaTag';

// head tag 탭 배열
const tabList = [
  {
    idx: 1,
    eventKey: 'metatag',
    name: '기본 메타태그',
  },
];

// 기본 메타태그 meta key
const defaultMetatag = [
  'site_meta_title_default',
  'site_meta_description_default',
  'site_meta_keywords_default',
  'site_page_name_default',
];

function Index() {
  const [allMetaTag, setAllMetaTag] = useState([]);         // 모든 환경 설정 값
  const [defaultMetaTag, setDefaultMetaTag] = useState({}); // 기본 메타태그

  // 환경 설정 불러오기
  const getMetaTagSetting = async () => {
    setAllMetaTag([]);
    setDefaultMetaTag({});

    await getConfiguration()
      .then(response => {
        if (response.data.success) {
          setAllMetaTag(response.data.result);
        }
        else {
          Swal.fire({
            icon: 'error',
            title: '환경 설정 - 메타태그를 불러올 수 없습니다.',
            text: '잠시 후 다시 시도해주세요.',
          }).then(() => {
            return;
          });
        }
      })
      .catch(error => {
        console.error('error occured in MetaTagConfig/Index.js - getMetaTagSetting() ', error);

        Swal.fire({
          icon: 'error',
          title: '환경 설정 - 메타태그를 불러올 수 없습니다.',
          text: '잠시 후 다시 시도해주세요.',
        }).then(() => {
          return;
        });
      });
  };

  useEffect(() => {
    getMetaTagSetting();
  }, []);

  // 기본 메타태그 state에 setting
  const settingDefaultMetaTag = () => {
    const tempObj = {};

    allMetaTag.forEach(element1 => {
      defaultMetatag.forEach(element2 => {
        if (element1.key === element2) {
          tempObj[element2] = element1.value;
        }
      });
    });
    
    setDefaultMetaTag(tempObj);
  };

  useEffect(() => {
    if (allMetaTag.length > 0) {
      settingDefaultMetaTag();
    }
  }, [allMetaTag]);

  return (
    <div>
      <SimpleHeader parentName="환경 설정" name="head tag 설정" />
      <Container className="mt--6" fluid>
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey={tabList[0].eventKey}
          transition={false}
        >
          <Card>
            <Card.Header>
              <Nav
                variant="tabs"
                className="flex-row"
                defaultActiveKey={tabList[0].eventKey}
              >
                {tabList.map((tab) => (
                  <Nav.Item key={tab.idx + tab.eventKey}>
                    <Nav.Link eventKey={tab.eventKey} className="px-4 py-2 text-sm">
                      {tab.name}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Card.Header>
            <Card.Body>
              <div className="pl-lg-4 pr-lg-4 pt-4">
                <Tab.Content>
                  <DefaultMetaTag tabEventKey={tabList[0].eventKey} metatag={defaultMetaTag} getMetaTagSetting={getMetaTagSetting} />
                </Tab.Content>
              </div>
            </Card.Body>
          </Card>
        </Tab.Container>
      </Container>
    </div>
  );
}

export default Index;
